var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?[_c('v-skeleton-loader',{attrs:{"type":"image","height":"145"}})]:[_c('dynamic-link',{attrs:{"to":_vm.banner.link,"append-class":"text-reset d-block lh-0"}},[_c('img',{staticClass:"img-fluid w-100",style:(`border-radius: ${_vm.radius}px`),attrs:{"src":_vm.addResourceImage(_vm.banner.img),"alt":_vm.appName}})])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }